import React from "react"
import PropTypes from "prop-types"

import { ProgressModal } from "@components/Page"

import useInvestmentsExport from "./helpers/useInvestmentsExport"

const LABEL_TITLE = "Export Investments"


const ExportInvestmentsModal = ({ modal }) => {
  const onReady = () => modal.current.close()

  const [ percent, start, stop, reset ] = useInvestmentsExport(onReady)

  const modalProps = {
    title: LABEL_TITLE,
    stop,
    reset,
    modal,
    start,
    percent,
  }

  return (
    <ProgressModal {...modalProps} />
  )
}


ExportInvestmentsModal.propTypes = {
  modal: PropTypes.shape().isRequired
}

export default ExportInvestmentsModal
